import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";

import { Button } from "@workspace/web-ui/components/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from "@workspace/web-ui/components/dropdown-menu";
import { Tabs, TabsList, TabsTrigger } from "@workspace/web-ui/components/tabs";
import { ChevronDownIcon, SettingsIcon } from "lucide-react";
import SettingsModal from "~/features/dashboard/pages/calendar/components/settings-modal";
import { useAppointmentsStore, useSettingsModal } from "~/features/dashboard/pages/calendar/store";

function CalendarLayout() {
  const { view, setView } = useAppointmentsStore();
  const{ open, isOpen, close} = useSettingsModal();
  const {program} = useParams({strict: false})
  return (
    <section
      className="flex w-full flex-col justify-center"
      role="region"
      aria-labelledby="calendar-heading"
    >
      <div className="flex flex-col gap-4 min-h-screen w-full px-4 py-6 md:py-12 sm:px-[32px] lg:px-[208px]">
        <div className="flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <h1 className="text-2xl font-bold">Calendar</h1>
          <div className="flex items-center gap-4">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" className="gap-1.5 max-[479px]:h-8">
                  <span>
                    <span className="min-[480px]:hidden" aria-hidden="true">
                      {view.charAt(0).toUpperCase() + view.slice(1)}
                    </span>
                    <span className="max-[479px]:sr-only">{view.charAt(0).toUpperCase() + view.slice(1)}</span>
                  </span>
                  <ChevronDownIcon className="-me-1 opacity-60" size={16} aria-hidden="true" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="min-w-32">
                <DropdownMenuItem onClick={() => setView("month")}>
                  Month <DropdownMenuShortcut>M</DropdownMenuShortcut>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => setView("week")}>
                  Week <DropdownMenuShortcut>W</DropdownMenuShortcut>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => setView("day")}>
                  Day <DropdownMenuShortcut>D</DropdownMenuShortcut>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>


            <Button onClick={open} className="rounded-[8px] bg-[#4272DD]">
              <SettingsIcon className="h-4 w-4" />
             <span className="flex">Calendar Settings</span> 
            </Button>
          </div>
        </div>
        <Tabs defaultValue="appointments" className="items-center">
          <TabsList className="text-foreground h-auto gap-2 rounded-none bg-transparent px-0 py-1">
            {/* <TabsTrigger
              value="consultations"
              className="hover:bg-accent hover:text-foreground data-[state=active]:after:bg-primary data-[state=active]:hover:bg-accent relative after:absolute after:inset-x-0 after:bottom-0 after:-mb-1 after:h-0.5 data-[state=active]:bg-transparent data-[state=active]:shadow-none"
            >
              Consultations
            </TabsTrigger> */}
            <TabsTrigger
              value="appointments"
              className="hover:bg-accent hover:text-foreground data-[state=active]:after:bg-primary data-[state=active]:hover:bg-accent relative after:absolute after:inset-x-0 after:bottom-0 after:-mb-1 after:h-0.5 data-[state=active]:bg-transparent data-[state=active]:shadow-none"
            >
              {program === "urgent-care" ? "Encounters" : "Appointments"}
            </TabsTrigger>
            <TabsTrigger
              value="medications"
              className="hover:bg-accent hover:text-foreground data-[state=active]:after:bg-primary data-[state=active]:hover:bg-accent relative after:absolute after:inset-x-0 after:bottom-0 after:-mb-1 after:h-0.5 data-[state=active]:bg-transparent data-[state=active]:shadow-none"
            >
              Medication refill
            </TabsTrigger>
          </TabsList>
          <Outlet />
        </Tabs>

      </div>
      <SettingsModal open={isOpen} onOpenChange={close}/>
    </section>
  );
}

export const Route = createFileRoute("/(dashboard)/dashboard/$program/calendar")({
  component: CalendarLayout,
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="p-4">
      <h2 className="text-xl font-bold">Error Loading Calendar Page</h2>
      <pre className="mt-4">{error.message}</pre>
    </div>
  ),
});
